import Seo from "@/lib/Seo";
import { FadeUp } from "@/lib/motion";
import { GALLERY } from "@/data/content";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function Gallery() {
  return (
    <div className="pt-[72px]">
      <Seo
        title="Gallery — Wedding Detail Inspiration | Marble & Veil"
        description="Design inspiration for Southern California celebrations: tablescapes, florals, stationery, and the moments between. Concept imagery while our real portfolio grows."
        path="/gallery"
      />
      <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
        <Breadcrumbs trail={[["Home", "/"], ["Gallery"]]} />
        <FadeUp>
          <h1 className="mt-6 font-display text-5xl leading-[1.05] text-ink sm:text-6xl">The Gallery</h1>
          <p className="mt-5 max-w-xl leading-relaxed text-smoke">
            A feeling, before it is a plan. The imagery below is clearly labeled{" "}
            <em className="font-display italic text-olive">design inspiration</em> — mood and craft we
            draw on while our own portfolio of celebrations grows. No image here is presented as Marble
            &amp; Veil event work.
          </p>
        </FadeUp>

        <div className="mt-16 columns-1 gap-5 sm:columns-2 lg:columns-3 [&>figure]:mb-5">
          {GALLERY.map((g, i) => (
            <FadeUp key={g.src} delay={(i % 3) * 0.06}>
              <figure className="group relative break-inside-avoid overflow-hidden bg-parch" data-testid={`gallery-item-${i}`}>
                <img src={g.src} alt={`${g.caption} — design inspiration`} className="w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" width="700" loading="lazy" />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/70 to-transparent p-4 pt-10 text-[11px] uppercase tracking-[0.16em] text-ivory">
                  {g.tag} · {g.caption}
                </figcaption>
              </figure>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.1}>
          <p className="mx-auto mt-16 max-w-xl border border-ink/10 bg-parch p-6 text-center text-sm leading-relaxed text-smoke" data-testid="gallery-provenance-note">
            Imagery provenance is tracked and reviewed with the owner. Real Marble &amp; Veil
            celebration photography will replace inspiration imagery only with the owner's approval.
          </p>
        </FadeUp>
      </section>
    </div>
  );
}
